export default {
    // Menu Roles y Permisos
    id: '5',
    routeName: "default",//Ruta por default
    interface: 'system',
    label: 'Sistema',
    isInterface: true,
    items: [
        // Users
        {
            id: '5.1',
            label: 'Usuarios',
            icon: "bx bx-user-circle",
            permission: 'system_users_list',
            routeName: 'system.users',
            isTitle: true,
            selected: false,
            subItems: [
                {
                    id: '5.1.1',
                    label: 'Gestión de Usuarios',
                    permission: 'system_users_list',
                    routeName: "system.users",
                    show: false
                },
                {
                    id: '5.1.1.1',
                    label: 'Crear Usuario',
                    permission: 'system_users_create',
                    routeName: "system.users.create",
                    show: false
                },
                {
                    id: '5.1.1.2',
                    label: 'Editar Usuario',
                    permission: 'system_users_edit',
                    routeName: "system.users.edit",
                    show: false
                }

            ]
        },
        // Submenu Control de Acceso
        {
            id: '5.2',
            label: 'Control de Acceso',
            icon: 'bx bx-shield-quarter',
            permissions: ['system_roles_list', 'system_roles_create', 'system_roles_edit'],
            isTitle: true,
            selected: true,
            subItems: [
                {
                    id: '5.2.1',
                    label: 'Roles',
                    permission: 'system_roles_list',
                    routeName: "system.roles",
                    show: true
                },
                {
                    id: '5.2.1.2',
                    label: 'Crear Rol',
                    routeName: "system.roles.create",
                    permission: 'system_roles_create',
                    show: false,
                },
                {
                    id: '5.2.1.3',
                    label: 'Editar Rol',
                    routeName: "system.roles.edit",
                    permission: 'system_roles_edit',
                    show: false,
                }
            ]
        },
    ]
} 